$('document').ready(function () {

    function courseMapReady() {
        let $courseAddressBlock = $('.js__course-address'),
            studioAddress  = $courseAddressBlock.data('studio-address'),
            studioName     = $courseAddressBlock.data('studio-name'),
            geocoder       = ymaps.geocode(studioAddress, {results: 1});

        geocoder.then(
            function (res) {
                let studioCoordinates = res.geoObjects.get(0).geometry.getCoordinates();
                let studioPlacemark   = new ymaps.Placemark(
                    studioCoordinates, {
                        hintContent: studioAddress,
                        balloonContentHeader: 'Студия: ' + studioName,
                        balloonContent: studioAddress,
                    }, {
                        iconLayout: 'default#image',
                        iconImageHref: '/build/site/images/circle_icon_map.png',
                        iconImageSize: [70, 77],
                    }
                );

                let courseMap  = new ymaps.Map('course-map', {
                    center: studioCoordinates,
                    zoom: 15,
                    behaviors: ['default', 'scrollZoom'],
                    type:  'yandex#map',
                    controls: [],
                },{
                    suppressMapOpenBlock: 0,
                    maxZoom: 17
                });

                courseMap.geoObjects.add(studioPlacemark);

            }
        );
    }

    ymaps.ready(courseMapReady);

    $('.js_course-save').on('click', function () {
        $('.course-modal').fadeIn();
    });
    $('.js_course-overlay').on('click', function (event) {
        let $target = $(event.target);

        if ($target.hasClass('modal__overlay')) {
            $('.course-modal').fadeOut();
        }
    });
    $('.js_course-close').on('click', function () {
        $('.course-modal').fadeOut();
    });

    jQuery(function($) {
        function fixButtons() {
            let mainHeaderHeight = $('.main-header').height(),
                $buttons         = $('.course-banner__buttons'),
                buttonsPosition  = $buttons.position().top;

            if ($(window).scrollTop() > (buttonsPosition + mainHeaderHeight)) {
                $buttons.addClass('course-banner__buttons_fixed');
            } else {
                $buttons.removeClass('course-banner__buttons_fixed');
            }
        }
        $(window).scroll(fixButtons);
        fixButtons();
    });
});